export default {
  namespaced: true,
  state     : {
    breadcrumbs: [
      {
        id      : 1,
        text    : 'Главная',
        disabled: false,
      },
      {
        id      : 2,
        text    : 'Магазин призов',
        disabled: true,
      },
    ],
  },
  getters: {
    breadcrumbs: ({breadcrumbs}) => breadcrumbs,
  },
};

